import { useState, useEffect } from "react";
import { connect } from "react-redux";

// @material-ui core components
import Icon from "@mui/material/Icon";
import Avatar from "@mui/material/Avatar";

import SuiAvatar from "components/sui/SuiAvatar";
import stringAvatar from "app/utils/stringAvatar";

import axios from "axios";

function CdxUserAvatar({ user, onClick, size = "sm" }) {
  const fullName = user.fbData.displayName || user.email;

  const [avatar, setAvatar] = useState(
    <SuiAvatar
      size={size}
      mx={5}
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
      bgColor="secondary"
    >
      <Icon>person</Icon>
    </SuiAvatar>
  );
  const [imageUrl, setImageUrl] = useState(user.fbData.photoURL || "");

  const [imageData, setImageData] = useState();

  const setImage = async (imageUrl) => {
    try {
      const response = await axios.get(imageUrl);
      setImageData(response.data);
    } catch {
      setImageData(null);
    }
  };

  useEffect(() => {
    if (imageUrl) {
      setImage(imageUrl);
    } else {
      setImageData(null);
    }
  }, [imageUrl]);

  useEffect(() => {
    setImageUrl(user.fbData.photoURL || "");
  }, [user.fbData.photoURL]);

  useEffect(() => {
    const renderAvatar = () => {
      if (imageData) {
        return (
          <>
            {imageData && (
              <SuiAvatar
                src={imageUrl}
                alt="Avatar"
                size={size}
                mx={5}
                onClick={onClick}
                sx={{ cursor: onClick ? "pointer" : "default" }}
              />
            )}
          </>
        );
      }
      if (fullName !== "Loading user information ...") {
        const sizeDict = {
          xs: 24,
          sm: 36,
          md: 48,
          lg: 58,
          xl: 74,
          xxl: 110,
        };

        const avatarSize = parseInt(size) ? parseInt(size) : sizeDict[size];

        let av = stringAvatar(fullName);
        av = {
          ...av,
          sx: {
            ...av.sx,
            cursor: onClick ? "pointer" : "default",
            width: avatarSize,
            height: avatarSize,
            fontSize: parseInt(avatarSize * 0.5),
          },
        };
        return (
          <>
            <Avatar {...av} mx={5} onClick={onClick} />
          </>
        );
      }
      return (
        <SuiAvatar
          size={size}
          mx={5}
          onClick={onClick}
          sx={{ cursor: onClick ? "pointer" : "default" }}
          bgColor="secondary"
        >
          <Icon>person</Icon>
        </SuiAvatar>
      );
    };

    setAvatar(renderAvatar());
  }, [user, fullName]); //, imageUrl, imageData, onClick]);

  return <>{avatar}</>;
  return (
    <SuiAvatar
      size={size}
      mx={5}
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
      bgColor="secondary"
    >
      <Icon>person</Icon>
    </SuiAvatar>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(CdxUserAvatar);
